export default function getGenericLanguage(code: string) {
  const locale = new Intl.Locale(code);
  return locale.language;
}
